import { writeBatch } from 'firebase/firestore';
import _ from "lodash";
import { dispatchProps } from "../cnr/reducers/reducerHelpers/dispatchProps";
import { dataFix } from "../common/dataFix";
import { gEnums } from "../enums/globalEnums";
import { createRefPath, createRefPath_event } from "../firestoreData/appData/appRefPaths";
import { addDataItemsToCollectionDatabase } from "../firestoreData/updates/subUpdates/addDataItemsToCollection";

export const createModes = {
  create: 'create',
  recreate: 'recreate',
  update: 'update'
}

const createGenericTypes = {
  createGeneric: 'createGeneric',
}

const createFunctionTypes = {
  createClient: 'createClient',
  createEvent: 'createEvent',
  createEvent_test: 'createEvent_test',
  createClient_event: 'createClient_event',
  createProject: 'createProject',
  createViewItem: 'createViewItem',
  createViewItemProps: 'createViewItemProps',
  createViewItemPropSection: 'createViewItemPropSection',
  createViewItems: 'createViewItems',
  createViews: 'createViews',
}

const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(createGenericTypes.createGeneric, callData)
  return data
}

export const fsfn_create = (fsCall, database_fns) => ({
  addViewAndViews: (vvProps, viewItems, views, pathViews) => addViewAndViews(fsCall, vvProps, viewItems, views, pathViews),
  createClientInDatabase: (callData) => fsfn_createClientInDatabase(fsCall, callData),
  createClientProjectSettings: (data, callback, logging) => fsfn_createClientProjectSettings(fsCall, data, callback, logging),
  createEventCollectionsInDatabase: (pathViews, dataCollections, deletePrior, handleUpdating, dispatch, mainFunctions) => fsfn_createEventCollectionsInDatabase(fsCall, pathViews, dataCollections, deletePrior, handleUpdating, dispatch, mainFunctions),
  createEventInDatabase: (fn_cls, callback, createInfo, recreate, logging, pathViews, databaseProjectId, addModeType, config_alt) => fsfn_createEventInDatabase(fn_cls, fsCall, callback, createInfo, recreate, logging, pathViews, databaseProjectId, addModeType, config_alt),
  createEvent_test: (regData) => fsfn_createEvent_test(fsCall, regData),
  createClient_event: (data) => fsfn_createClient_event(fsCall, data),
  createProject: (callData) => fsfn_createProject(fsCall, callData),
  createViewItem: (viKey, forGlobal, existingViewItems, count) => fsfn_createViewItem(fsCall, viKey, forGlobal, existingViewItems, count),
  createViewItemProps: (propsToAdd, existingProps, propSection) => fsfn_createViewItemProps(fsCall, propsToAdd, existingProps, propSection),
  createViewItemPropSection: (name, count, propSections) => fsfn_createViewItemPropSection(fsCall, name, count, propSections),
  createViewItems: (viewItemKeys, existingViewItems, newProps) => fsfn_createViewItems(fsCall, viewItemKeys, existingViewItems, newProps),
  createViews: (viewItems, existingViews, directReturn, newProps) => fsfn_createViews(fsCall, viewItems, existingViews, directReturn, newProps),
  // recreateEventInDatabase: (fn_cls,state, callback) => fsfn_recreateEventInDatabase(fn_cls, fsCall, state, callback),
  createEventCollections: async (mainDb, pathViews, dataCollections) => createEventCollections(database_fns, fsCall, mainDb, pathViews, dataCollections),
})

export async function createEventCollections(database_fns, mainDb, pathViews, dataCollections) {

  const _pathViews = {
    clients: pathViews.clients,
    events: database_fns.get_docKey()
  }

  const baseRef = createRefPath_event(_pathViews)

  const BATCH_LIMIT = 500;

  let batches = [];
  let currentBatch = writeBatch(mainDb);
  let opCount = 0;

  _.forEach(dataCollections, (dataCollection, collectionName) => {
    if (!_.isPlainObject(dataCollection)) return;

    _.forEach(dataCollection, (dci, dciKey) => {
      if (!_.isPlainObject(dci)) return;

      const docKey = database_fns.get_docKey()
      const docRef = createRefPath([collectionName, docKey], baseRef);

      currentBatch.set(docRef, dci);
      opCount++;

      if (opCount === BATCH_LIMIT) {
        batches.push(currentBatch);
        currentBatch = writeBatch(mainDb);
        opCount = 0;
      }
    });
  });

  if (opCount > 0) {
    batches.push(currentBatch);
  }

  await Promise.all(batches.map(batch => batch.commit()));

  const result = {
    success: true,
    message: `Imported ${batches.length} batch(es) across ${_.keys(dataCollections).length} collections.`,
  };

  console.log('result', result)

  return result
}


const addViewAndViews = async (fsCall, vvProps, viewItems, views, pathViews) => {

  const { name: name_new, copyFrom, attachTo } = vvProps
  const _viewItems_events = views?.events?.viewItems
  const _viewItems_clients = views?.clients?.viewItems

  if (name_new) {
    const _nameNew_cc = _.camelCase(name_new)

    if (copyFrom) {
      // get the viewItem, view and viewList from the main viewItems and views objects
      const _viewItem_cf = { ..._.cloneDeep(viewItems[copyFrom]) }
      const _view_cf = { ..._.cloneDeep(views[copyFrom]) }
      const _viewList_cf = { ..._.cloneDeep(views[copyFrom + '_list']) }

      _view_cf.viewItems = _.pick(_view_cf.viewItems, [copyFrom])
      _view_cf.viewItems[_nameNew_cc] = _view_cf.viewItems[copyFrom]
      delete _view_cf.viewItems[copyFrom]

      _viewList_cf.viewItems = _.pick(_viewList_cf.viewItems, [copyFrom])
      _viewList_cf.viewItems[_nameNew_cc] = _viewList_cf.viewItems[copyFrom]
      delete _viewList_cf.viewItems[copyFrom]

      _viewItem_cf.key = _nameNew_cc

      ammendItem(_view_cf, _nameNew_cc, copyFrom)
      ammendItem(_viewList_cf, _nameNew_cc, copyFrom, true)

      viewItems[_nameNew_cc] = _viewItem_cf
      views[_nameNew_cc] = _view_cf
      views[_nameNew_cc + '_list'] = _viewList_cf

      if (attachTo) {
        _.forEach(attachTo, atKey => {
          const view_at = views[atKey]
          const view_at_vi = view_at?.viewItems[atKey]
          if (!view_at?.viewItems[_nameNew_cc]) {
            if (view_at_vi?.display?.cardDisplayType === gEnums.cardDisplayTypes.profilePlus) {
              view_at_vi.display.cardDisplayType = gEnums.cardDisplayTypes.profile
            }
            if (view_at_vi?.desktopDisplay?.cardDisplayType === gEnums.cardDisplayTypes.profilePlus) {
              view_at_vi.desktopDisplay.cardDisplayType = gEnums.cardDisplayTypes.profile
            }
            console.log('view_at_vi', view_at_vi)
            view_at.viewItems[_nameNew_cc] = view_at_vi
          }
        })
      }

      if (_viewItems_events && !_viewItems_events[name_new]) {
        _viewItems_events[name_new] = _viewItem_cf
      }

    } else {
      // viewItems are the EXISTING viewItems
      await fsfn_createViewItem(fsCall, _nameNew_cc, true, viewItems, _.size(viewItems))
      const _view_items = {
        [_nameNew_cc]: viewItems[_nameNew_cc]
      }
      await fsfn_createViews(fsCall, _view_items, views, true)

      // add the new item to eithe events or clientss
      if (pathViews.events && _viewItems_events && !_viewItems_events[name_new]) {
        _viewItems_events[name_new] = _view_items[_nameNew_cc]
      } else if (!pathViews.events && pathViews.clients && _viewItems_clients && !_viewItems_clients[name_new]) {
        _viewItems_clients[name_new] = _view_items[_nameNew_cc]

      }
    }

  }
}

const ammendItem = (item, name, copyFrom, addClickTo) => {
  item.menu.caption = _.startCase(name)
  // item.viewItems[name] = item.viewItems[copyFrom]
  item.viewItems[name].key = name
  item.viewItems[name].display.caption = _.startCase(name)
  if (!item.viewItems[name].dataSource) { item.viewItems[name].dataSource = {} }
  item.viewItems[name].dataSource.altDataCollectionName = copyFrom
  if (addClickTo) {
    item.viewItems[name].itemClick = {
      clickToType: gEnums.clickToTypes.page,
      clickToPage: copyFrom
    }
  }
}

const fsfn_createClient_event = async (fsCall, data) => {
  try {
    const callData = {
      createFunctionType: createFunctionTypes.createClient_event,
      clientName: 'test',
      eventName: 'test',
      data,
      showLogs: true,
    }
    const response_data = await callFsFunction(fsCall, fsCall, callData)
    return response_data
  } catch (error) {

  }
}


const fsfn_createEvent_test = async (fsCall, regData) => {
  try {
    const callData = {
      createFunctionType: createFunctionTypes.createEvent_test,
      clientName: 'test',
      eventName: 'test',
      data: regData,
      showLogs: true,
      ignoreDataModifications: true
    }
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {

  }
}

/**
 * No callback
 * @param {object} state {previewInfo, pathViews, storageRootPath}
 * @param {function} callback 
 * @returns createResult
 * @description deletes and then recreates the event in the database
 */
// const fsfn_recreateEventInDatabase = async (fn_cls, state, callback) => {
//   const { previewInfo, pathViews, storageRootPath, databaseProjectId } = state ?? {}
//   const { projectData } = previewInfo ? previewInfo : {}
//   const { dataCollections } = projectData ?? {}

//   if (dataCollections) {
//     const viewItemKeys = Object.keys(dataCollections)
//     const response_data = await fn_cls.deleteFullEventFromDatabase(pathViews, viewItemKeys, storageRootPath)
//     const { success, error } = response_data
//     if (success) {
//       if (success) {
//         previewInfo.projectData.eventData.id = pathViews.events
//         fsfn_createEventInDatabase(callback, previewInfo, true, null, pathViews, databaseProjectId)
//       } else if (error) {
//         callback(createResult(false, {}, error))
//       }
//     } else {
//       callback(createResult(false, {}, error))
//     }
//   }
// }

const removeEmptyValues = (obj) => {
  const isEmptyValue = (value) => {
    return (
      (_.isEmpty(value) && !_.isBoolean(value)) || // Exclude booleans from being considered empty
      value === null ||                           // Removes null
      value === undefined                         // Removes undefined
    );
  };

  const clean = (value) => {
    if (_.isArray(value)) {
      // Filter and recursively clean arrays
      return value.map(clean).filter(v => !isEmptyValue(v));
    } else if (_.isObject(value)) {
      // Recursively clean objects and remove keys with empty values
      return _.transform(value, (result, v, key) => {
        if (key === '') return; // Skip if the key is an empty string
        const cleanedValue = clean(v);
        if (!isEmptyValue(cleanedValue)) {
          result[key] = cleanedValue;
        }
      }, {});
    }
    // Return the value directly if it's not an object/array
    return value;
  };

  return clean(obj);
};

/**
 * This will create an event in the database using `createEvent` in functions
 * @param {*} allowUpdates 
 * @param {*} createInfo 
 * @param {*} logging 
 * @returns response_data {success, result, error}
 */
const fsfn_createEventInDatabase = async (fn_cls, fsCall, callback, createInfo, recreate, logging, pathViews, databaseProjectId, addModeType, config_alt) => {
  try {
    // const { createInfo, showLogs, useGenericId } = data ?? {}
    const callData = {
      createFunctionType: createFunctionTypes.createEvent,
      createInfo,
      showLogs: true,// logging && logging.allowLogging && logging.logCreateEvent,
      useGenericId: recreate ? false : true,
      databaseProjectId: config_alt && config_alt.projectId ? config_alt.projectId : databaseProjectId,
      addModeType,
    }

    switch (addModeType) {
      case gEnums.addModeTypes.googleSheetsOnly:
        callData.createInfo.projectSettings.global.appDataSource.appDataSourceType = gEnums.dataSourceTypes.googleSheet
        break;
      default:
      // nothing
    }

    createInfo.projectSettings.global = dataFix.removeEmptyValues(createInfo.projectSettings.global)
    createInfo.projectSettings.viewItems = dataFix.removeEmptyValues(createInfo.projectSettings.viewItems)
    createInfo.projectSettings.views = dataFix.removeEmptyValues(createInfo.projectSettings.views)

    createInfo.projectData = removeEmptyValues(createInfo.projectData)
    createInfo.projectSettings = removeEmptyValues(createInfo.projectSettings)

    const { projectData } = createInfo
    const { eventData } = projectData

    // give the event an id
    if (eventData && !eventData.id && eventData.name) { eventData.id = eventData.name }

    eventData.name = createInfo?.projectSettings?.global?.topMenu?.mainFixedCaption
    delete eventData.id

    createInfo.mode = recreate ? createModes.recreate : createModes.create

    if (recreate) {
      const viewItemKeys = createInfo && createInfo.projectData && createInfo.projectData.dataCollections ? Object.keys(createInfo.projectData.dataCollections) : []
      const response_data = await fn_cls.deleteFullEventFromDatabase(pathViews, viewItemKeys, null, true)
      callback({ result: response_data })
    } else {
      const response_data = await callFsFunction(fsCall, callData)
      callback({ result: response_data })
      // return response_data
    }
  } catch (error) {
    callback({ error })
    console.error(error)
  }
}

/**
 * Creates a client in the database
 * @param {object} callData (createInfo, forProd)
 * @returns  
 */
const fsfn_createClientInDatabase = async (fsCall, callData) => {
  try {
    // const { createInfo } = callData
    // const { projectData } = createInfo ?? {}
    // const { clientData } = projectData ?? {}
    // const { name } = clientData ? clientData : {}

    callData.createFunctionType = createFunctionTypes.createClient
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/** Creates the settings for a new client using functions */
const fsfn_createClientProjectSettings = async (fsCall, data, callback, logging) => {
  try {
    const callData = { createFunctionType: createFunctionTypes.createProject, initialData: { ...data.viewItems }, showLogs: logging && logging.allowLogging && logging.logCreateClientProject }
    callData.createClient = true
    callData.initialData.clients.dataItems = { name: data.clientName }
    callData.clientName = data.clientName
    const response_data = await callFsFunction(fsCall, callData, true) // OK 
    if (response_data?.result?.projectData?.clientData) {
      response_data.result.projectData.clientData.clientType = data.clientType
      response_data.result.projectData.clientData.clientKey = data.clientKey
    }
    if (callback) { callback(response_data) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * This will create the eventInfo using firebase functions `createProject`. This does NOT update the database
 * @param {*} callData ( clientName, createClient, direct, eventName, initialData, keepRowIds, showLogs)
 * @returns response_data {success, result, error}
 */
const fsfn_createProject = async (fsCall, callData) => {

  try {
    callData.showLogs = true
    callData.createFunctionType = createFunctionTypes.createProject
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {array} viewItemKeys 
 * @param {object} existingViewItems 
 * @description - creates new viewItems (result) based on the viewItemKeys and adds them the existingViewItems
 */
const fsfn_createViewItems = async (fsCall, viewItemKeys, existingViewItems, newProps) => {
  try {
    const callData = { createFunctionType: createFunctionTypes.createViewItems, newProps, viewItemKeys, existingViewItemKeys: Object.keys(existingViewItems) }
    const { success, result: viewItems } = await callFsFunction(fsCall, callData) // OK
    if (success && viewItems) {
      Object.keys(viewItems).forEach(key => {
        existingViewItems[key] = viewItems[key]
      })
    }
  } catch (error) {
    console.error('fsfn_createViewItems: error', error)
  }
}

/**
 * 
 * @param {string} viKey 
 * @param {boolean} forGlobal 
 * @param {object} existingViewItems 
 * @description Creates a new viewItem and adds it the existingViewItems
 */
const fsfn_createViewItem = async (fsCall, viKey, forGlobal, existingViewItems, count) => {
  try {
    const callData = { createFunctionType: createFunctionTypes.createViewItem, viKey, forGlobal, createGenericProps: true, createPropSections: true, count }
    const { success, result: viewItem } = await callFsFunction(fsCall, callData) // OK
    if (success && viewItem) {
      existingViewItems[viKey] = viewItem
    }
  } catch (error) {
    console.error('fsfn_createViewItem: error', error)
  }
}

/**
 * 
 * @param {object} viewItems - List of existing viewItems. These are objects
 * @param {object} existingViews 
 * @description Creates a new viewItem and adds it the existingViews
 */
const fsfn_createViews = async (fsCall, viewItems, existingViews, directReturn, newProps) => {
  try {
    // viewItems, existingViews, directReturn
    const callData = { createFunctionType: createFunctionTypes.createViews, viewItems, existingViews, directReturn, newProps }
    const { success, result: newViews } = await callFsFunction(fsCall, callData) // OK
    if (success && newViews) {
      Object.keys(newViews).forEach(key => {
        const newView = newViews[key]
        existingViews[key] = newView
        // add the new view item to the event's view items
        // if (!viewItems_events[key] && newView.viewItems && newView.viewItems[key]) {
        //   viewItems_events[key] = newView.viewItems[key]
        //   viewItems_events[key].display.caption = _.startCase(key)
        //   viewItems_events[key].show = false
        //   viewItems_events[key].showDesktop = false
        // }
      })
    }
    return { views: newViews }
  } catch (error) {
    console.error(error)
  }
}


/** Create new props for the viewItem with the propSection and add them to existingProps after */
// newProps, propSection:
const fsfn_createViewItemProps = async (fsCall, propsToAdd, existingProps, propSection) => {
  try {
    const callData = { createFunctionType: createFunctionTypes.createViewItemProps, newProps: propsToAdd, propSection } //existingProps
    const { success, result: props } = await callFsFunction(fsCall, callData) // OK 
    if (success && props) {
      props.forEach(prop => {
        existingProps[prop.key] = prop
      })
    }
  } catch (error) {
    console.error(error)
  }
}

/** Create new props for the viewItem */
const fsfn_createViewItemPropSection = async (fsCall, name, count, propSections) => {
  const callData = { createFunctionType: createFunctionTypes.createViewItemPropSection, name, count, propSections }
  try {
    const { success, result: section } = await callFsFunction(fsCall, callData) // OK
    if (success && section) {
      section.key = name
      propSections[name] = section
    }
  } catch (error) {
    console.error(error)
  }
}



/**
 * 
 * @param {string} pathViews The database path for the event
 * @param {array} dataCollections List of collection items to be updated
 * @param {function} handleUpdating The callback function to notify the UI
 * @param {function} dispatch The callback function when complete
 * @description Loops through the `dataCollections` and adds them using 
 */
const fsfn_createEventCollectionsInDatabase = async (fn_cls, pathViews, dataCollections, deletePrior, handleUpdating, dispatch, mainFunctions) => {
  try {
    Object.keys(dataCollections).forEach(async (dcKey, index) => {
      const dataToUpdate = dataCollections[dcKey]
      handleUpdating && handleUpdating(dcKey)
      if (deletePrior) {
        await fn_cls.deleteClientCollection(pathViews, dcKey, 100, mainFunctions)
      }
      addDataItemsToCollectionDatabase(pathViews, dcKey, dataToUpdate, false, dispatch)
    })
  } catch (err) {
    dispatch && dispatch({ type: dispatchProps.error, error: err })
  }
}


